const common = {
  Loading: "Carregando",
  signUp: "Registrar",
  login: "Login",
  logout: "Logout",
  email: "E-mail",
  emailFormatErrorTips: "O formato do e-mail é incorreto",
  emailDifferentTips: "Por favor, digite o mesmo e-mail em ambos os campos.",
  emailRegisteredTips: "O e-mail foi registrado, por favor, escolha outro e-mail.",
  password: "Senha",
  passwordFormatErrorTips:
    "A senha deve ter de 8 a 50 caracteres e conter pelo menos duas categorias entre as seguintes: número, letra ou caracter especial.",
  passwordDifferentTips: "Por favor, digite a mesma senha em ambos os campos.",
  verificationCode: "Código de verificação",
  verificationCodeErrorTips: "Código de verificação incorreto",
  confirm: "Confirmar",
  cancel: "Cancelar",
  submit: "Enviar",
  confirmEmail: "Confirmar E-mail",
  formEmptyErrorTips: "Aqui não pode estar vazio.",
  country: "País/Região",
  birthday: "Data de nascimento",
  anonymous: "Anônimo",
  name: "Nome",
  nameFormatErrorTips: "O nome de usuário deve estar dentro de 50 caracteres e não deve conter caracteres especiais",
  okBtn: "OK",
  serverErrorTips: "Desculpe, algo deu errado, por favor, tente novamente mais tarde.",
  updateSuccessTips: "Alterado com sucesso",
  authorizationExpiredErrorTips: "A autorização expirou, por favor, faça o login novamente.",
  requestFrequentlyErrorTips: "Demasiados pedidos foram feitos em um curto período de tempo, por favor, tente novamente mais tarde.",
};

export default common;
